var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.6666L14 12.6666C14.1215 12.6662 14.2406 12.6327 14.3444 12.5697C14.4483 12.5067 14.533 12.4165 14.5895 12.3089C14.6459 12.2013 14.6719 12.0804 14.6647 11.9591C14.6575 11.8378 14.6174 11.7208 14.5487 11.6206L8.54866 2.95395C8.3 2.59461 7.70133 2.59461 7.452 2.95395L1.452 11.6206C1.38255 11.7206 1.34182 11.8377 1.33424 11.9591C1.32666 12.0806 1.35252 12.2019 1.40901 12.3097C1.46549 12.4175 1.55045 12.5078 1.65464 12.5707C1.75883 12.6336 1.87828 12.6668 2 12.6666Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.99164d1b43a3f12b8b1879ceda0cd9d8.svg";
export { ForwardRef as ReactComponent };